/* Kanadeal — ligne "points gagnes" dans le panier (page + tiroir), maj dynamique. */
(function(){
  if(window.__kdCartPointsInit) return;
  window.__kdCartPointsInit=true;
  var RATE=1;
  function parsePrice(t){
    t=(t||'').replace(/[^0-9.,]/g,'');
    if(t.indexOf(',')>-1 && t.indexOf('.')>-1){ t=t.replace(/\./g,'').replace(',','.'); }
    else if(t.indexOf(',')>-1){ t=t.replace(',','.'); }
    var v=parseFloat(t); return isFinite(v)?v:0;
  }
  function fr(n){ try{return n.toLocaleString('fr-FR');}catch(e){return ''+n;} }
  function scan(){
    var list=document.querySelectorAll('.cart__ctas');
    for(var i=0;i<list.length;i++){
      var ctas=list[i], summary=ctas.parentNode; if(!summary) continue;
      var totalEl=summary.querySelector('[ref="cartTotal"]')||summary.querySelector('.cart-totals__total-value')||summary.querySelector('[data-cart-subtotal]');
      if(!totalEl) continue;
      var pts=Math.max(0,Math.floor(parsePrice(totalEl.textContent)*RATE));
      var line=summary.querySelector('.kdcp');
      if(pts<=0){ if(line) line.parentNode.removeChild(line); continue; }
      if(!line){ line=document.createElement('div'); line.className='kdcp'; summary.insertBefore(line,ctas); }
      if(line.getAttribute('data-kpts')!==String(pts)){
        line.setAttribute('data-kpts',String(pts));
        line.innerHTML='<span class="kdcp__coin">🪙</span><span>Cette commande te rapporte <b>'+fr(pts)+' point'+(pts>1?'s':'')+'</b><span class="kdcp__sub">Cumulés sur ton compte Club Kanadeal</span></span>';
      }
    }
  }
  var t=null;
  function schedule(){ if(t) return; t=setTimeout(function(){t=null;scan();},120); }
  function init(){
    scan();
    try{ new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true}); }catch(e){}
    [400,1200,2500].forEach(function(d){setTimeout(scan,d);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
